import { BaseUserProfile, ProgramType } from 'fitbeat.models';
import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import { SafeAreaView, StyleSheet, View } from 'react-native';
import Theme, { ThemeType } from '../theme';
import { LongTermGoalTile, OnBoardingHeader, OnBoardingProgress } from './components';
import { styles as SharedStyles } from './SignupFormsStyles';

interface IProps {
  t: (key: string) => string;
  user: any;
  navigation: any;
}

class LongTermGoal extends PureComponent<IProps, {}> {
  public viewGoalDescription = (longTermGoal: ProgramType) => {
    this.props.navigation.navigate('LongTermGoalDescription', { longTermGoal });
  }

  public render() {
    const { t } = this.props;
    const { userProfile } = this.props.user;
    const showMobilityGoal = BaseUserProfile.isHomeAccountType(userProfile) ||
      BaseUserProfile.isFeatureEnabledForUser('beta', userProfile);
    return (
      <SafeAreaView style={{ flex: 1, backgroundColor: Theme.WHITE }}>
        <OnBoardingProgress step={5} />
        <View style={[SharedStyles.container, styles.containerStyle]}>
          <OnBoardingHeader
            header={t('setYourLongTermFitnessGoal')}
            subheader={t('forPersonalisedWorkoutsAndNutrition')}
            theme={ThemeType.light}
          />
          <View style={styles.listContainer}>
            <LongTermGoalTile
              useInline
              theme={ThemeType.light}
              programType={ProgramType.GetStrongAndFitGoal}
              onPress={() => this.viewGoalDescription(ProgramType.GetStrongAndFitGoal)}
            />
            <LongTermGoalTile
              useInline
              theme={ThemeType.light}
              programType={ProgramType.GainMuscleAndStrengthGoal}
              onPress={() => this.viewGoalDescription(ProgramType.GainMuscleAndStrengthGoal)}
            />
            <LongTermGoalTile
              useInline
              theme={ThemeType.light}
              programType={ProgramType.MobilityAndTone}
              onPress={() => this.viewGoalDescription(ProgramType.MobilityAndTone)}
            />
            <LongTermGoalTile
              useInline
              theme={ThemeType.light}
              programType={ProgramType.GetLeanAndFitGoal}
              onPress={() => this.viewGoalDescription(ProgramType.GetLeanAndFitGoal)}
            />
            <LongTermGoalTile
              useInline
              theme={ThemeType.light}
              programType={ProgramType.MuscleAndShred}
              onPress={() => this.viewGoalDescription(ProgramType.MuscleAndShred)}
            />
          </View>
        </View>
      </SafeAreaView>
    );
  }
}

const styles = StyleSheet.create({
  containerStyle: {
    flex: 1,
    justifyContent: 'center',
    paddingBottom: 30,
  },
  listContainer: {
    paddingTop: 10,
  },
});

export const LongTermGoalScreen = translate(['auth', 'formFields'], { wait: true })(LongTermGoal);
